module.exports = __webpack_public_path__ + "assets/media/heart-about.ca4fa9e4.svg";